/* This file is auto-generated with figma-svg. */
import hoc from '@hh.ru/magritte-ui-icon/hoc';
import { AndroidBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AndroidBrandSize16';
import { AndroidBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AndroidBrandSize24';
import { AndroidGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AndroidGrayscaleSize16';
import { AndroidGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AndroidGrayscaleSize24';
import { AndroidSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AndroidSolidSize16';
import { AndroidSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AndroidSolidSize24';
import { AppleBrandAltSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AppleBrandAltSize16';
import { AppleBrandAltSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AppleBrandAltSize24';
import { AppleBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AppleBrandSize16';
import { AppleBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AppleBrandSize24';
import { AppleGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AppleGrayscaleSize16';
import { AppleGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AppleGrayscaleSize24';
import { AppleSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AppleSolidSize16';
import { AppleSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/AppleSolidSize24';
import { ClickmeBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ClickmeBrandSize16';
import { ClickmeBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ClickmeBrandSize24';
import { ClickmeGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ClickmeGrayscaleSize16';
import { ClickmeGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ClickmeGrayscaleSize24';
import { ClickmeSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ClickmeSolidSize16';
import { ClickmeSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ClickmeSolidSize24';
import { DnrBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DnrBrandSize16';
import { DnrBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DnrBrandSize24';
import { DnrGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DnrGrayscaleSize16';
import { DnrGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DnrGrayscaleSize24';
import { DnrSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DnrSolidSize16';
import { DnrSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DnrSolidSize24';
import { DreamjobBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DreamjobBrandSize16';
import { DreamjobBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DreamjobBrandSize24';
import { DreamjobGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DreamjobGrayscaleSize16';
import { DreamjobGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DreamjobGrayscaleSize24';
import { DreamjobSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DreamjobSolidSize16';
import { DreamjobSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DreamjobSolidSize24';
import { DzenBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DzenBrandSize16';
import { DzenBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DzenBrandSize24';
import { DzenGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DzenGrayscaleSize16';
import { DzenGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DzenGrayscaleSize24';
import { DzenSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DzenSolidSize16';
import { DzenSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/DzenSolidSize24';
import { EsiaBrandAltSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/EsiaBrandAltSize16';
import { EsiaBrandAltSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/EsiaBrandAltSize24';
import { EsiaBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/EsiaBrandSize16';
import { EsiaBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/EsiaBrandSize24';
import { EsiaGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/EsiaGrayscaleSize16';
import { EsiaGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/EsiaGrayscaleSize24';
import { EsiaSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/EsiaSolidSize16';
import { EsiaSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/EsiaSolidSize24';
import { FacebookBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FacebookBrandSize16';
import { FacebookBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FacebookBrandSize24';
import { FacebookGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FacebookGrayscaleSize16';
import { FacebookGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FacebookGrayscaleSize24';
import { FacebookSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FacebookSolidSize16';
import { FacebookSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FacebookSolidSize24';
import { FlBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FlBrandSize16';
import { FlBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FlBrandSize24';
import { FlGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FlGrayscaleSize16';
import { FlGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FlGrayscaleSize24';
import { FlSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FlSolidSize16';
import { FlSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/FlSolidSize24';
import { GithubBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GithubBrandSize16';
import { GithubBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GithubBrandSize24';
import { GithubGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GithubGrayscaleSize16';
import { GithubGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GithubGrayscaleSize24';
import { GithubSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GithubSolidSize16';
import { GithubSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GithubSolidSize24';
import { GoogleBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GoogleBrandSize16';
import { GoogleBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GoogleBrandSize24';
import { GoogleGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GoogleGrayscaleSize16';
import { GoogleGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GoogleGrayscaleSize24';
import { GoogleSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GoogleSolidSize16';
import { GoogleSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/GoogleSolidSize24';
import { HhBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBrandSize16';
import { HhBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBrandSize24';
import { HhBusinessAppBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBusinessAppBrandSize16';
import { HhBusinessAppBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBusinessAppBrandSize24';
import { HhBusinessAppBrandSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBusinessAppBrandSize48';
import { HhBusinessAppGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBusinessAppGrayscaleSize16';
import { HhBusinessAppGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBusinessAppGrayscaleSize24';
import { HhBusinessAppGrayscaleSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBusinessAppGrayscaleSize48';
import { HhBusinessAppSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBusinessAppSolidSize16';
import { HhBusinessAppSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBusinessAppSolidSize24';
import { HhBusinessAppSolidSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhBusinessAppSolidSize48';
import { HhGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhGrayscaleSize16';
import { HhGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhGrayscaleSize24';
import { HhProBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhProBrandSize16';
import { HhProBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhProBrandSize24';
import { HhProBrandSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhProBrandSize32';
import { HhProGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhProGrayscaleSize16';
import { HhProGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhProGrayscaleSize24';
import { HhProGrayscaleSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhProGrayscaleSize32';
import { HhProSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhProSolidSize16';
import { HhProSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhProSolidSize24';
import { HhProSolidSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhProSolidSize32';
import { HhSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhSolidSize16';
import { HhSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HhSolidSize24';
import { HrLinkBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HrLinkBrandSize16';
import { HrLinkBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HrLinkBrandSize24';
import { HrLinkGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HrLinkGrayscaleSize16';
import { HrLinkGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HrLinkGrayscaleSize24';
import { HrLinkSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HrLinkSolidSize16';
import { HrLinkSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/HrLinkSolidSize24';
import { IbsBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IbsBrandSize16';
import { IbsBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IbsBrandSize24';
import { IbsBrandSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IbsBrandSize32';
import { IbsGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IbsGrayscaleSize16';
import { IbsGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IbsGrayscaleSize24';
import { IbsGrayscaleSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IbsGrayscaleSize32';
import { IbsSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IbsSolidSize16';
import { IbsSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IbsSolidSize24';
import { IbsSolidSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IbsSolidSize32';
import { IcqBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IcqBrandSize16';
import { IcqBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IcqBrandSize24';
import { IcqGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IcqGrayscaleSize16';
import { IcqGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IcqGrayscaleSize24';
import { IcqSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IcqSolidSize16';
import { IcqSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IcqSolidSize24';
import { ImessageBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ImessageBrandSize16';
import { ImessageBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ImessageBrandSize24';
import { ImessageGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ImessageGrayscaleSize16';
import { ImessageGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ImessageGrayscaleSize24';
import { ImessageSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ImessageSolidSize16';
import { ImessageSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ImessageSolidSize24';
import { IndexBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IndexBrandSize16';
import { IndexBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IndexBrandSize24';
import { IndexGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IndexGrayscaleSize16';
import { IndexGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IndexGrayscaleSize24';
import { IndexSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IndexSolidSize16';
import { IndexSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/IndexSolidSize24';
import { InstagramBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/InstagramBrandSize16';
import { InstagramBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/InstagramBrandSize24';
import { InstagramGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/InstagramGrayscaleSize16';
import { InstagramGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/InstagramGrayscaleSize24';
import { InstagramSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/InstagramSolidSize16';
import { InstagramSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/InstagramSolidSize24';
import { LinkedinBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LinkedinBrandSize16';
import { LinkedinBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LinkedinBrandSize24';
import { LinkedinGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LinkedinGrayscaleSize16';
import { LinkedinGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LinkedinGrayscaleSize24';
import { LinkedinSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LinkedinSolidSize16';
import { LinkedinSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LinkedinSolidSize24';
import { LivejournalBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LivejournalBrandSize16';
import { LivejournalBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LivejournalBrandSize24';
import { LivejournalGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LivejournalGrayscaleSize16';
import { LivejournalGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LivejournalGrayscaleSize24';
import { LivejournalSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LivejournalSolidSize16';
import { LivejournalSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/LivejournalSolidSize24';
import { MailBrandAltSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MailBrandAltSize16';
import { MailBrandAltSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MailBrandAltSize24';
import { MailBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MailBrandSize16';
import { MailBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MailBrandSize24';
import { MailGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MailGrayscaleSize16';
import { MailGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MailGrayscaleSize24';
import { MailSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MailSolidSize16';
import { MailSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MailSolidSize24';
import { MaxBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxBrandSize16';
import { MaxBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxBrandSize24';
import { MaxGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxGrayscaleSize16';
import { MaxGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxGrayscaleSize24';
import { MaxSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxSolidSize16';
import { MaxSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxSolidSize24';
import { MaxSquareBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxSquareBrandSize16';
import { MaxSquareBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxSquareBrandSize24';
import { MaxSquareGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxSquareGrayscaleSize16';
import { MaxSquareGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxSquareGrayscaleSize24';
import { MaxSquareSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxSquareSolidSize16';
import { MaxSquareSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MaxSquareSolidSize24';
import { MediumBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MediumBrandSize16';
import { MediumBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MediumBrandSize24';
import { MediumSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MediumSize16';
import { MediumSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MediumSize24';
import { MediumSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MediumSolidSize16';
import { MediumSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/MediumSolidSize24';
import { OkBrandAltSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OkBrandAltSize16';
import { OkBrandAltSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OkBrandAltSize24';
import { OkBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OkBrandSize16';
import { OkBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OkBrandSize24';
import { OkGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OkGrayscaleSize16';
import { OkGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OkGrayscaleSize24';
import { OkSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OkSolidSize16';
import { OkSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OkSolidSize24';
import { OneCBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OneCBrandSize16';
import { OneCBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OneCBrandSize24';
import { OneCBrandSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OneCBrandSize32';
import { OneCGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OneCGrayscaleSize16';
import { OneCGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OneCGrayscaleSize24';
import { OneCGrayscaleSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OneCGrayscaleSize32';
import { OneCSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OneCSolidSize16';
import { OneCSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OneCSolidSize24';
import { OneCSolidSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/OneCSolidSize32';
import { RabotaByAppBrandAltSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppBrandAltSize16';
import { RabotaByAppBrandAltSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppBrandAltSize24';
import { RabotaByAppBrandAltSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppBrandAltSize48';
import { RabotaByAppBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppBrandSize16';
import { RabotaByAppBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppBrandSize24';
import { RabotaByAppBrandSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppBrandSize48';
import { RabotaByAppGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppGrayscaleSize16';
import { RabotaByAppGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppGrayscaleSize24';
import { RabotaByAppGrayscaleSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppGrayscaleSize48';
import { RabotaByAppSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppSolidSize16';
import { RabotaByAppSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppSolidSize24';
import { RabotaByAppSolidSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByAppSolidSize48';
import { RabotaByBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByBrandSize16';
import { RabotaByBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByBrandSize24';
import { RabotaByGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByGrayscaleSize16';
import { RabotaByGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaByGrayscaleSize24';
import { RabotaBySolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaBySolidSize16';
import { RabotaBySolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/RabotaBySolidSize24';
import { SetkaBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaBrandSize16';
import { SetkaBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaBrandSize24';
import { SetkaBrandSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaBrandSize32';
import { SetkaBrandSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaBrandSize48';
import { SetkaGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaGrayscaleSize16';
import { SetkaGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaGrayscaleSize24';
import { SetkaGrayscaleSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaGrayscaleSize32';
import { SetkaGrayscaleSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaGrayscaleSize48';
import { SetkaSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaSolidSize16';
import { SetkaSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaSolidSize24';
import { SetkaSolidSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaSolidSize32';
import { SetkaSolidSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SetkaSolidSize48';
import { SkillazBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SkillazBrandSize16';
import { SkillazBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SkillazBrandSize24';
import { SkypeBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SkypeBrandSize16';
import { SkypeBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SkypeBrandSize24';
import { SkypeGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SkypeGrayscaleSize16';
import { SkypeGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SkypeGrayscaleSize24';
import { SkypeSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SkypeSolidSize16';
import { SkypeSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/SkypeSolidSize24';
import { StackoverflowBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/StackoverflowBrandSize16';
import { StackoverflowBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/StackoverflowBrandSize24';
import { StackoverflowGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/StackoverflowGrayscaleSize16';
import { StackoverflowGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/StackoverflowGrayscaleSize24';
import { StackoverflowSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/StackoverflowSolidSize16';
import { StackoverflowSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/StackoverflowSolidSize24';
import { TalantixBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TalantixBrandSize16';
import { TalantixBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TalantixBrandSize24';
import { TalantixGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TalantixGrayscaleSize16';
import { TalantixGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TalantixGrayscaleSize24';
import { TalantixLiteSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TalantixLiteSize16';
import { TalantixLiteSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TalantixLiteSize24';
import { TalantixSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TalantixSolidSize16';
import { TalantixSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TalantixSolidSize24';
import { TelegramBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TelegramBrandSize16';
import { TelegramBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TelegramBrandSize24';
import { TelegramGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TelegramGrayscaleSize16';
import { TelegramGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TelegramGrayscaleSize24';
import { TelegramSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TelegramSolidSize16';
import { TelegramSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TelegramSolidSize24';
import { TinkoffBrandAltSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffBrandAltSize16';
import { TinkoffBrandAltSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffBrandAltSize24';
import { TinkoffBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffBrandSize16';
import { TinkoffBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffBrandSize24';
import { TinkoffGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffGrayscaleSize16';
import { TinkoffGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffGrayscaleSize24';
import { TinkoffIdBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffIdBrandSize16';
import { TinkoffIdBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffIdBrandSize24';
import { TinkoffIdGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffIdGrayscaleSize16';
import { TinkoffIdGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffIdGrayscaleSize24';
import { TinkoffIdSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffIdSolidSize16';
import { TinkoffIdSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffIdSolidSize24';
import { TinkoffSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffSolidSize16';
import { TinkoffSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TinkoffSolidSize24';
import { TwitterBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TwitterBrandSize16';
import { TwitterBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TwitterBrandSize24';
import { TwitterGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TwitterGrayscaleSize16';
import { TwitterGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TwitterGrayscaleSize24';
import { TwitterSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TwitterSolidSize16';
import { TwitterSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/TwitterSolidSize24';
import { ViberBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ViberBrandSize16';
import { ViberBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ViberBrandSize24';
import { ViberGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ViberGrayscaleSize16';
import { ViberGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ViberGrayscaleSize24';
import { ViberSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ViberSolidSize16';
import { ViberSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ViberSolidSize24';
import { VkBrandAltSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkBrandAltSize16';
import { VkBrandAltSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkBrandAltSize24';
import { VkBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkBrandSize16';
import { VkBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkBrandSize24';
import { VkGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkGrayscaleSize16';
import { VkGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkGrayscaleSize24';
import { VkSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkSolidSize16';
import { VkSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkSolidSize24';
import { VkSquareBrandAltSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkSquareBrandAltSize16';
import { VkSquareBrandAltSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkSquareBrandAltSize24';
import { VkSquareBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkSquareBrandSize16';
import { VkSquareBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkSquareBrandSize24';
import { VkSquareGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkSquareGrayscaleSize16';
import { VkSquareGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkSquareGrayscaleSize24';
import { VkSquareSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkSquareSolidSize16';
import { VkSquareSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/VkSquareSolidSize24';
import { WhatsappBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/WhatsappBrandSize16';
import { WhatsappBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/WhatsappBrandSize24';
import { WhatsappGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/WhatsappGrayscaleSize16';
import { WhatsappGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/WhatsappGrayscaleSize24';
import { WhatsappSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/WhatsappSolidSize16';
import { WhatsappSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/WhatsappSolidSize24';
import { YandexBrandAltSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexBrandAltSize16';
import { YandexBrandAltSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexBrandAltSize24';
import { YandexBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexBrandSize16';
import { YandexBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexBrandSize24';
import { YandexCloudBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexCloudBrandSize16';
import { YandexCloudBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexCloudBrandSize24';
import { YandexCloudBrandSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexCloudBrandSize32';
import { YandexCloudGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexCloudGrayscaleSize16';
import { YandexCloudGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexCloudGrayscaleSize24';
import { YandexCloudGrayscaleSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexCloudGrayscaleSize32';
import { YandexCloudSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexCloudSolidSize16';
import { YandexCloudSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexCloudSolidSize24';
import { YandexCloudSolidSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexCloudSolidSize32';
import { YandexGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexGrayscaleSize16';
import { YandexGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexGrayscaleSize24';
import { YandexSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexSolidSize16';
import { YandexSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/YandexSolidSize24';
import { ZarplataBrandSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ZarplataBrandSize16';
import { ZarplataBrandSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ZarplataBrandSize24';
import { ZarplataGrayscaleSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ZarplataGrayscaleSize16';
import { ZarplataGrayscaleSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ZarplataGrayscaleSize24';
import { ZarplataSolidSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ZarplataSolidSize16';
import { ZarplataSolidSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/service/ZarplataSolidSize24';

export const WhatsappBrandSize16 = /* #__PURE__*/ hoc<'WhatsappBrandSize16'>(
    WhatsappBrandSize16Glyph,
    'WhatsappBrandSize16'
);
export const ZarplataGrayscaleSize16 = /* #__PURE__*/ hoc<'ZarplataGrayscaleSize16'>(
    ZarplataGrayscaleSize16Glyph,
    'ZarplataGrayscaleSize16'
);
export const ZarplataGrayscaleSize24 = /* #__PURE__*/ hoc<'ZarplataGrayscaleSize24'>(
    ZarplataGrayscaleSize24Glyph,
    'ZarplataGrayscaleSize24'
);
export const ZarplataBrandSize16 = /* #__PURE__*/ hoc<'ZarplataBrandSize16'>(
    ZarplataBrandSize16Glyph,
    'ZarplataBrandSize16'
);
export const ZarplataBrandSize24 = /* #__PURE__*/ hoc<'ZarplataBrandSize24'>(
    ZarplataBrandSize24Glyph,
    'ZarplataBrandSize24'
);
export const HrLinkGrayscaleSize24 = /* #__PURE__*/ hoc<'HrLinkGrayscaleSize24'>(
    HrLinkGrayscaleSize24Glyph,
    'HrLinkGrayscaleSize24'
);
export const HrLinkGrayscaleSize16 = /* #__PURE__*/ hoc<'HrLinkGrayscaleSize16'>(
    HrLinkGrayscaleSize16Glyph,
    'HrLinkGrayscaleSize16'
);
export const HrLinkBrandSize16 = /* #__PURE__*/ hoc<'HrLinkBrandSize16'>(HrLinkBrandSize16Glyph, 'HrLinkBrandSize16');
export const HhBrandSize24 = /* #__PURE__*/ hoc<'HhBrandSize24'>(HhBrandSize24Glyph, 'HhBrandSize24');
export const ImessageGrayscaleSize24 = /* #__PURE__*/ hoc<'ImessageGrayscaleSize24'>(
    ImessageGrayscaleSize24Glyph,
    'ImessageGrayscaleSize24'
);
export const FacebookGrayscaleSize24 = /* #__PURE__*/ hoc<'FacebookGrayscaleSize24'>(
    FacebookGrayscaleSize24Glyph,
    'FacebookGrayscaleSize24'
);
export const SetkaGrayscaleSize24 = /* #__PURE__*/ hoc<'SetkaGrayscaleSize24'>(
    SetkaGrayscaleSize24Glyph,
    'SetkaGrayscaleSize24'
);
export const RabotaBySolidSize16 = /* #__PURE__*/ hoc<'RabotaBySolidSize16'>(
    RabotaBySolidSize16Glyph,
    'RabotaBySolidSize16'
);
export const SetkaGrayscaleSize32 = /* #__PURE__*/ hoc<'SetkaGrayscaleSize32'>(
    SetkaGrayscaleSize32Glyph,
    'SetkaGrayscaleSize32'
);
export const SetkaGrayscaleSize16 = /* #__PURE__*/ hoc<'SetkaGrayscaleSize16'>(
    SetkaGrayscaleSize16Glyph,
    'SetkaGrayscaleSize16'
);
export const SetkaGrayscaleSize48 = /* #__PURE__*/ hoc<'SetkaGrayscaleSize48'>(
    SetkaGrayscaleSize48Glyph,
    'SetkaGrayscaleSize48'
);
export const TalantixBrandSize16 = /* #__PURE__*/ hoc<'TalantixBrandSize16'>(
    TalantixBrandSize16Glyph,
    'TalantixBrandSize16'
);
export const HhGrayscaleSize16 = /* #__PURE__*/ hoc<'HhGrayscaleSize16'>(HhGrayscaleSize16Glyph, 'HhGrayscaleSize16');
export const TalantixGrayscaleSize16 = /* #__PURE__*/ hoc<'TalantixGrayscaleSize16'>(
    TalantixGrayscaleSize16Glyph,
    'TalantixGrayscaleSize16'
);
export const VkSquareBrandSize16 = /* #__PURE__*/ hoc<'VkSquareBrandSize16'>(
    VkSquareBrandSize16Glyph,
    'VkSquareBrandSize16'
);
export const VkGrayscaleSize24 = /* #__PURE__*/ hoc<'VkGrayscaleSize24'>(VkGrayscaleSize24Glyph, 'VkGrayscaleSize24');
export const VkGrayscaleSize16 = /* #__PURE__*/ hoc<'VkGrayscaleSize16'>(VkGrayscaleSize16Glyph, 'VkGrayscaleSize16');
export const DreamjobBrandSize24 = /* #__PURE__*/ hoc<'DreamjobBrandSize24'>(
    DreamjobBrandSize24Glyph,
    'DreamjobBrandSize24'
);
export const DnrBrandSize24 = /* #__PURE__*/ hoc<'DnrBrandSize24'>(DnrBrandSize24Glyph, 'DnrBrandSize24');
export const SkypeBrandSize24 = /* #__PURE__*/ hoc<'SkypeBrandSize24'>(SkypeBrandSize24Glyph, 'SkypeBrandSize24');
export const FacebookBrandSize24 = /* #__PURE__*/ hoc<'FacebookBrandSize24'>(
    FacebookBrandSize24Glyph,
    'FacebookBrandSize24'
);
export const WhatsappGrayscaleSize16 = /* #__PURE__*/ hoc<'WhatsappGrayscaleSize16'>(
    WhatsappGrayscaleSize16Glyph,
    'WhatsappGrayscaleSize16'
);
export const MailGrayscaleSize24 = /* #__PURE__*/ hoc<'MailGrayscaleSize24'>(
    MailGrayscaleSize24Glyph,
    'MailGrayscaleSize24'
);
export const FacebookGrayscaleSize16 = /* #__PURE__*/ hoc<'FacebookGrayscaleSize16'>(
    FacebookGrayscaleSize16Glyph,
    'FacebookGrayscaleSize16'
);
export const DnrBrandSize16 = /* #__PURE__*/ hoc<'DnrBrandSize16'>(DnrBrandSize16Glyph, 'DnrBrandSize16');
export const VkSquareGrayscaleSize24 = /* #__PURE__*/ hoc<'VkSquareGrayscaleSize24'>(
    VkSquareGrayscaleSize24Glyph,
    'VkSquareGrayscaleSize24'
);
export const OkSolidSize24 = /* #__PURE__*/ hoc<'OkSolidSize24'>(OkSolidSize24Glyph, 'OkSolidSize24');
export const IndexBrandSize16 = /* #__PURE__*/ hoc<'IndexBrandSize16'>(IndexBrandSize16Glyph, 'IndexBrandSize16');
export const WhatsappBrandSize24 = /* #__PURE__*/ hoc<'WhatsappBrandSize24'>(
    WhatsappBrandSize24Glyph,
    'WhatsappBrandSize24'
);
export const DzenBrandSize24 = /* #__PURE__*/ hoc<'DzenBrandSize24'>(DzenBrandSize24Glyph, 'DzenBrandSize24');
export const IndexGrayscaleSize16 = /* #__PURE__*/ hoc<'IndexGrayscaleSize16'>(
    IndexGrayscaleSize16Glyph,
    'IndexGrayscaleSize16'
);
export const OkGrayscaleSize24 = /* #__PURE__*/ hoc<'OkGrayscaleSize24'>(OkGrayscaleSize24Glyph, 'OkGrayscaleSize24');
export const SkillazBrandSize16 = /* #__PURE__*/ hoc<'SkillazBrandSize16'>(
    SkillazBrandSize16Glyph,
    'SkillazBrandSize16'
);
export const LinkedinBrandSize24 = /* #__PURE__*/ hoc<'LinkedinBrandSize24'>(
    LinkedinBrandSize24Glyph,
    'LinkedinBrandSize24'
);
export const TalantixGrayscaleSize24 = /* #__PURE__*/ hoc<'TalantixGrayscaleSize24'>(
    TalantixGrayscaleSize24Glyph,
    'TalantixGrayscaleSize24'
);
export const DreamjobGrayscaleSize16 = /* #__PURE__*/ hoc<'DreamjobGrayscaleSize16'>(
    DreamjobGrayscaleSize16Glyph,
    'DreamjobGrayscaleSize16'
);
export const LinkedinBrandSize16 = /* #__PURE__*/ hoc<'LinkedinBrandSize16'>(
    LinkedinBrandSize16Glyph,
    'LinkedinBrandSize16'
);
export const TalantixBrandSize24 = /* #__PURE__*/ hoc<'TalantixBrandSize24'>(
    TalantixBrandSize24Glyph,
    'TalantixBrandSize24'
);
export const DreamjobGrayscaleSize24 = /* #__PURE__*/ hoc<'DreamjobGrayscaleSize24'>(
    DreamjobGrayscaleSize24Glyph,
    'DreamjobGrayscaleSize24'
);
export const YandexBrandSize24 = /* #__PURE__*/ hoc<'YandexBrandSize24'>(YandexBrandSize24Glyph, 'YandexBrandSize24');
export const TelegramGrayscaleSize16 = /* #__PURE__*/ hoc<'TelegramGrayscaleSize16'>(
    TelegramGrayscaleSize16Glyph,
    'TelegramGrayscaleSize16'
);
export const TelegramGrayscaleSize24 = /* #__PURE__*/ hoc<'TelegramGrayscaleSize24'>(
    TelegramGrayscaleSize24Glyph,
    'TelegramGrayscaleSize24'
);
export const YandexBrandSize16 = /* #__PURE__*/ hoc<'YandexBrandSize16'>(YandexBrandSize16Glyph, 'YandexBrandSize16');
export const AppleGrayscaleSize24 = /* #__PURE__*/ hoc<'AppleGrayscaleSize24'>(
    AppleGrayscaleSize24Glyph,
    'AppleGrayscaleSize24'
);
export const MailGrayscaleSize16 = /* #__PURE__*/ hoc<'MailGrayscaleSize16'>(
    MailGrayscaleSize16Glyph,
    'MailGrayscaleSize16'
);
export const MediumSize16 = /* #__PURE__*/ hoc<'MediumSize16'>(MediumSize16Glyph, 'MediumSize16');
export const MediumSize24 = /* #__PURE__*/ hoc<'MediumSize24'>(MediumSize24Glyph, 'MediumSize24');
export const DzenBrandSize16 = /* #__PURE__*/ hoc<'DzenBrandSize16'>(DzenBrandSize16Glyph, 'DzenBrandSize16');
export const MediumBrandSize24 = /* #__PURE__*/ hoc<'MediumBrandSize24'>(MediumBrandSize24Glyph, 'MediumBrandSize24');
export const IndexGrayscaleSize24 = /* #__PURE__*/ hoc<'IndexGrayscaleSize24'>(
    IndexGrayscaleSize24Glyph,
    'IndexGrayscaleSize24'
);
export const MediumBrandSize16 = /* #__PURE__*/ hoc<'MediumBrandSize16'>(MediumBrandSize16Glyph, 'MediumBrandSize16');
export const GithubGrayscaleSize16 = /* #__PURE__*/ hoc<'GithubGrayscaleSize16'>(
    GithubGrayscaleSize16Glyph,
    'GithubGrayscaleSize16'
);
export const GithubGrayscaleSize24 = /* #__PURE__*/ hoc<'GithubGrayscaleSize24'>(
    GithubGrayscaleSize24Glyph,
    'GithubGrayscaleSize24'
);
export const LinkedinGrayscaleSize24 = /* #__PURE__*/ hoc<'LinkedinGrayscaleSize24'>(
    LinkedinGrayscaleSize24Glyph,
    'LinkedinGrayscaleSize24'
);
export const YandexBrandAltSize16 = /* #__PURE__*/ hoc<'YandexBrandAltSize16'>(
    YandexBrandAltSize16Glyph,
    'YandexBrandAltSize16'
);
export const HhProGrayscaleSize32 = /* #__PURE__*/ hoc<'HhProGrayscaleSize32'>(
    HhProGrayscaleSize32Glyph,
    'HhProGrayscaleSize32'
);
export const HhProGrayscaleSize16 = /* #__PURE__*/ hoc<'HhProGrayscaleSize16'>(
    HhProGrayscaleSize16Glyph,
    'HhProGrayscaleSize16'
);
export const DnrSolidSize24 = /* #__PURE__*/ hoc<'DnrSolidSize24'>(DnrSolidSize24Glyph, 'DnrSolidSize24');
export const YandexBrandAltSize24 = /* #__PURE__*/ hoc<'YandexBrandAltSize24'>(
    YandexBrandAltSize24Glyph,
    'YandexBrandAltSize24'
);
export const VkSquareBrandSize24 = /* #__PURE__*/ hoc<'VkSquareBrandSize24'>(
    VkSquareBrandSize24Glyph,
    'VkSquareBrandSize24'
);
export const GithubBrandSize16 = /* #__PURE__*/ hoc<'GithubBrandSize16'>(GithubBrandSize16Glyph, 'GithubBrandSize16');
export const OkBrandSize24 = /* #__PURE__*/ hoc<'OkBrandSize24'>(OkBrandSize24Glyph, 'OkBrandSize24');
export const IcqBrandSize16 = /* #__PURE__*/ hoc<'IcqBrandSize16'>(IcqBrandSize16Glyph, 'IcqBrandSize16');
export const TwitterBrandSize24 = /* #__PURE__*/ hoc<'TwitterBrandSize24'>(
    TwitterBrandSize24Glyph,
    'TwitterBrandSize24'
);
export const AndroidBrandSize16 = /* #__PURE__*/ hoc<'AndroidBrandSize16'>(
    AndroidBrandSize16Glyph,
    'AndroidBrandSize16'
);
export const IcqBrandSize24 = /* #__PURE__*/ hoc<'IcqBrandSize24'>(IcqBrandSize24Glyph, 'IcqBrandSize24');
export const GoogleGrayscaleSize24 = /* #__PURE__*/ hoc<'GoogleGrayscaleSize24'>(
    GoogleGrayscaleSize24Glyph,
    'GoogleGrayscaleSize24'
);
export const YandexGrayscaleSize24 = /* #__PURE__*/ hoc<'YandexGrayscaleSize24'>(
    YandexGrayscaleSize24Glyph,
    'YandexGrayscaleSize24'
);
export const ViberGrayscaleSize16 = /* #__PURE__*/ hoc<'ViberGrayscaleSize16'>(
    ViberGrayscaleSize16Glyph,
    'ViberGrayscaleSize16'
);
export const WhatsappGrayscaleSize24 = /* #__PURE__*/ hoc<'WhatsappGrayscaleSize24'>(
    WhatsappGrayscaleSize24Glyph,
    'WhatsappGrayscaleSize24'
);
export const ViberBrandSize16 = /* #__PURE__*/ hoc<'ViberBrandSize16'>(ViberBrandSize16Glyph, 'ViberBrandSize16');
export const TwitterBrandSize16 = /* #__PURE__*/ hoc<'TwitterBrandSize16'>(
    TwitterBrandSize16Glyph,
    'TwitterBrandSize16'
);
export const AppleBrandAltSize16 = /* #__PURE__*/ hoc<'AppleBrandAltSize16'>(
    AppleBrandAltSize16Glyph,
    'AppleBrandAltSize16'
);
export const FacebookBrandSize16 = /* #__PURE__*/ hoc<'FacebookBrandSize16'>(
    FacebookBrandSize16Glyph,
    'FacebookBrandSize16'
);
export const GoogleBrandSize24 = /* #__PURE__*/ hoc<'GoogleBrandSize24'>(GoogleBrandSize24Glyph, 'GoogleBrandSize24');
export const AppleGrayscaleSize16 = /* #__PURE__*/ hoc<'AppleGrayscaleSize16'>(
    AppleGrayscaleSize16Glyph,
    'AppleGrayscaleSize16'
);
export const ImessageBrandSize16 = /* #__PURE__*/ hoc<'ImessageBrandSize16'>(
    ImessageBrandSize16Glyph,
    'ImessageBrandSize16'
);
export const TinkoffSolidSize24 = /* #__PURE__*/ hoc<'TinkoffSolidSize24'>(
    TinkoffSolidSize24Glyph,
    'TinkoffSolidSize24'
);
export const DzenGrayscaleSize24 = /* #__PURE__*/ hoc<'DzenGrayscaleSize24'>(
    DzenGrayscaleSize24Glyph,
    'DzenGrayscaleSize24'
);
export const StackoverflowBrandSize24 = /* #__PURE__*/ hoc<'StackoverflowBrandSize24'>(
    StackoverflowBrandSize24Glyph,
    'StackoverflowBrandSize24'
);
export const FlGrayscaleSize16 = /* #__PURE__*/ hoc<'FlGrayscaleSize16'>(FlGrayscaleSize16Glyph, 'FlGrayscaleSize16');
export const LivejournalGrayscaleSize16 = /* #__PURE__*/ hoc<'LivejournalGrayscaleSize16'>(
    LivejournalGrayscaleSize16Glyph,
    'LivejournalGrayscaleSize16'
);
export const StackoverflowBrandSize16 = /* #__PURE__*/ hoc<'StackoverflowBrandSize16'>(
    StackoverflowBrandSize16Glyph,
    'StackoverflowBrandSize16'
);
export const EsiaBrandAltSize16 = /* #__PURE__*/ hoc<'EsiaBrandAltSize16'>(
    EsiaBrandAltSize16Glyph,
    'EsiaBrandAltSize16'
);
export const SkypeGrayscaleSize16 = /* #__PURE__*/ hoc<'SkypeGrayscaleSize16'>(
    SkypeGrayscaleSize16Glyph,
    'SkypeGrayscaleSize16'
);
export const EsiaBrandAltSize24 = /* #__PURE__*/ hoc<'EsiaBrandAltSize24'>(
    EsiaBrandAltSize24Glyph,
    'EsiaBrandAltSize24'
);
export const SkypeGrayscaleSize24 = /* #__PURE__*/ hoc<'SkypeGrayscaleSize24'>(
    SkypeGrayscaleSize24Glyph,
    'SkypeGrayscaleSize24'
);
export const FlBrandSize24 = /* #__PURE__*/ hoc<'FlBrandSize24'>(FlBrandSize24Glyph, 'FlBrandSize24');
export const StackoverflowGrayscaleSize24 = /* #__PURE__*/ hoc<'StackoverflowGrayscaleSize24'>(
    StackoverflowGrayscaleSize24Glyph,
    'StackoverflowGrayscaleSize24'
);
export const FlGrayscaleSize24 = /* #__PURE__*/ hoc<'FlGrayscaleSize24'>(FlGrayscaleSize24Glyph, 'FlGrayscaleSize24');
export const HhBrandSize16 = /* #__PURE__*/ hoc<'HhBrandSize16'>(HhBrandSize16Glyph, 'HhBrandSize16');
export const IndexBrandSize24 = /* #__PURE__*/ hoc<'IndexBrandSize24'>(IndexBrandSize24Glyph, 'IndexBrandSize24');
export const LivejournalBrandSize16 = /* #__PURE__*/ hoc<'LivejournalBrandSize16'>(
    LivejournalBrandSize16Glyph,
    'LivejournalBrandSize16'
);
export const LivejournalBrandSize24 = /* #__PURE__*/ hoc<'LivejournalBrandSize24'>(
    LivejournalBrandSize24Glyph,
    'LivejournalBrandSize24'
);
export const DnrGrayscaleSize16 = /* #__PURE__*/ hoc<'DnrGrayscaleSize16'>(
    DnrGrayscaleSize16Glyph,
    'DnrGrayscaleSize16'
);
export const DnrGrayscaleSize24 = /* #__PURE__*/ hoc<'DnrGrayscaleSize24'>(
    DnrGrayscaleSize24Glyph,
    'DnrGrayscaleSize24'
);
export const GoogleGrayscaleSize16 = /* #__PURE__*/ hoc<'GoogleGrayscaleSize16'>(
    GoogleGrayscaleSize16Glyph,
    'GoogleGrayscaleSize16'
);
export const YandexGrayscaleSize16 = /* #__PURE__*/ hoc<'YandexGrayscaleSize16'>(
    YandexGrayscaleSize16Glyph,
    'YandexGrayscaleSize16'
);
export const TwitterGrayscaleSize16 = /* #__PURE__*/ hoc<'TwitterGrayscaleSize16'>(
    TwitterGrayscaleSize16Glyph,
    'TwitterGrayscaleSize16'
);
export const VkBrandAltSize24 = /* #__PURE__*/ hoc<'VkBrandAltSize24'>(VkBrandAltSize24Glyph, 'VkBrandAltSize24');
export const TwitterGrayscaleSize24 = /* #__PURE__*/ hoc<'TwitterGrayscaleSize24'>(
    TwitterGrayscaleSize24Glyph,
    'TwitterGrayscaleSize24'
);
export const StackoverflowGrayscaleSize16 = /* #__PURE__*/ hoc<'StackoverflowGrayscaleSize16'>(
    StackoverflowGrayscaleSize16Glyph,
    'StackoverflowGrayscaleSize16'
);
export const VkBrandAltSize16 = /* #__PURE__*/ hoc<'VkBrandAltSize16'>(VkBrandAltSize16Glyph, 'VkBrandAltSize16');
export const ImessageBrandSize24 = /* #__PURE__*/ hoc<'ImessageBrandSize24'>(
    ImessageBrandSize24Glyph,
    'ImessageBrandSize24'
);
export const LinkedinGrayscaleSize16 = /* #__PURE__*/ hoc<'LinkedinGrayscaleSize16'>(
    LinkedinGrayscaleSize16Glyph,
    'LinkedinGrayscaleSize16'
);
export const HhProGrayscaleSize24 = /* #__PURE__*/ hoc<'HhProGrayscaleSize24'>(
    HhProGrayscaleSize24Glyph,
    'HhProGrayscaleSize24'
);
export const LivejournalGrayscaleSize24 = /* #__PURE__*/ hoc<'LivejournalGrayscaleSize24'>(
    LivejournalGrayscaleSize24Glyph,
    'LivejournalGrayscaleSize24'
);
export const ImessageGrayscaleSize16 = /* #__PURE__*/ hoc<'ImessageGrayscaleSize16'>(
    ImessageGrayscaleSize16Glyph,
    'ImessageGrayscaleSize16'
);
export const FlBrandSize16 = /* #__PURE__*/ hoc<'FlBrandSize16'>(FlBrandSize16Glyph, 'FlBrandSize16');
export const TinkoffSolidSize16 = /* #__PURE__*/ hoc<'TinkoffSolidSize16'>(
    TinkoffSolidSize16Glyph,
    'TinkoffSolidSize16'
);
export const HhGrayscaleSize24 = /* #__PURE__*/ hoc<'HhGrayscaleSize24'>(HhGrayscaleSize24Glyph, 'HhGrayscaleSize24');
export const TinkoffBrandAltSize24 = /* #__PURE__*/ hoc<'TinkoffBrandAltSize24'>(
    TinkoffBrandAltSize24Glyph,
    'TinkoffBrandAltSize24'
);
export const OkBrandSize16 = /* #__PURE__*/ hoc<'OkBrandSize16'>(OkBrandSize16Glyph, 'OkBrandSize16');
export const VkBrandSize24 = /* #__PURE__*/ hoc<'VkBrandSize24'>(VkBrandSize24Glyph, 'VkBrandSize24');
export const DzenGrayscaleSize16 = /* #__PURE__*/ hoc<'DzenGrayscaleSize16'>(
    DzenGrayscaleSize16Glyph,
    'DzenGrayscaleSize16'
);
export const VkSquareGrayscaleSize16 = /* #__PURE__*/ hoc<'VkSquareGrayscaleSize16'>(
    VkSquareGrayscaleSize16Glyph,
    'VkSquareGrayscaleSize16'
);
export const OkBrandAltSize24 = /* #__PURE__*/ hoc<'OkBrandAltSize24'>(OkBrandAltSize24Glyph, 'OkBrandAltSize24');
export const AndroidBrandSize24 = /* #__PURE__*/ hoc<'AndroidBrandSize24'>(
    AndroidBrandSize24Glyph,
    'AndroidBrandSize24'
);
export const ViberGrayscaleSize24 = /* #__PURE__*/ hoc<'ViberGrayscaleSize24'>(
    ViberGrayscaleSize24Glyph,
    'ViberGrayscaleSize24'
);
export const OkBrandAltSize16 = /* #__PURE__*/ hoc<'OkBrandAltSize16'>(OkBrandAltSize16Glyph, 'OkBrandAltSize16');
export const VkBrandSize16 = /* #__PURE__*/ hoc<'VkBrandSize16'>(VkBrandSize16Glyph, 'VkBrandSize16');
export const GoogleBrandSize16 = /* #__PURE__*/ hoc<'GoogleBrandSize16'>(GoogleBrandSize16Glyph, 'GoogleBrandSize16');
export const TinkoffBrandAltSize16 = /* #__PURE__*/ hoc<'TinkoffBrandAltSize16'>(
    TinkoffBrandAltSize16Glyph,
    'TinkoffBrandAltSize16'
);
export const TinkoffGrayscaleSize24 = /* #__PURE__*/ hoc<'TinkoffGrayscaleSize24'>(
    TinkoffGrayscaleSize24Glyph,
    'TinkoffGrayscaleSize24'
);
export const SkillazBrandSize24 = /* #__PURE__*/ hoc<'SkillazBrandSize24'>(
    SkillazBrandSize24Glyph,
    'SkillazBrandSize24'
);
export const TinkoffGrayscaleSize16 = /* #__PURE__*/ hoc<'TinkoffGrayscaleSize16'>(
    TinkoffGrayscaleSize16Glyph,
    'TinkoffGrayscaleSize16'
);
export const ViberBrandSize24 = /* #__PURE__*/ hoc<'ViberBrandSize24'>(ViberBrandSize24Glyph, 'ViberBrandSize24');
export const VkSolidSize16 = /* #__PURE__*/ hoc<'VkSolidSize16'>(VkSolidSize16Glyph, 'VkSolidSize16');
export const OkGrayscaleSize16 = /* #__PURE__*/ hoc<'OkGrayscaleSize16'>(OkGrayscaleSize16Glyph, 'OkGrayscaleSize16');
export const IcqGrayscaleSize16 = /* #__PURE__*/ hoc<'IcqGrayscaleSize16'>(
    IcqGrayscaleSize16Glyph,
    'IcqGrayscaleSize16'
);
export const IcqGrayscaleSize24 = /* #__PURE__*/ hoc<'IcqGrayscaleSize24'>(
    IcqGrayscaleSize24Glyph,
    'IcqGrayscaleSize24'
);
export const AndroidGrayscaleSize16 = /* #__PURE__*/ hoc<'AndroidGrayscaleSize16'>(
    AndroidGrayscaleSize16Glyph,
    'AndroidGrayscaleSize16'
);
export const TinkoffBrandSize16 = /* #__PURE__*/ hoc<'TinkoffBrandSize16'>(
    TinkoffBrandSize16Glyph,
    'TinkoffBrandSize16'
);
export const AndroidGrayscaleSize24 = /* #__PURE__*/ hoc<'AndroidGrayscaleSize24'>(
    AndroidGrayscaleSize24Glyph,
    'AndroidGrayscaleSize24'
);
export const TinkoffBrandSize24 = /* #__PURE__*/ hoc<'TinkoffBrandSize24'>(
    TinkoffBrandSize24Glyph,
    'TinkoffBrandSize24'
);
export const DreamjobBrandSize16 = /* #__PURE__*/ hoc<'DreamjobBrandSize16'>(
    DreamjobBrandSize16Glyph,
    'DreamjobBrandSize16'
);
export const SkypeSolidSize16 = /* #__PURE__*/ hoc<'SkypeSolidSize16'>(SkypeSolidSize16Glyph, 'SkypeSolidSize16');
export const SkypeBrandSize16 = /* #__PURE__*/ hoc<'SkypeBrandSize16'>(SkypeBrandSize16Glyph, 'SkypeBrandSize16');
export const TelegramBrandSize24 = /* #__PURE__*/ hoc<'TelegramBrandSize24'>(
    TelegramBrandSize24Glyph,
    'TelegramBrandSize24'
);
export const TelegramBrandSize16 = /* #__PURE__*/ hoc<'TelegramBrandSize16'>(
    TelegramBrandSize16Glyph,
    'TelegramBrandSize16'
);
export const LivejournalSolidSize24 = /* #__PURE__*/ hoc<'LivejournalSolidSize24'>(
    LivejournalSolidSize24Glyph,
    'LivejournalSolidSize24'
);
export const AppleBrandAltSize24 = /* #__PURE__*/ hoc<'AppleBrandAltSize24'>(
    AppleBrandAltSize24Glyph,
    'AppleBrandAltSize24'
);
export const HhProBrandSize16 = /* #__PURE__*/ hoc<'HhProBrandSize16'>(HhProBrandSize16Glyph, 'HhProBrandSize16');
export const HhProBrandSize32 = /* #__PURE__*/ hoc<'HhProBrandSize32'>(HhProBrandSize32Glyph, 'HhProBrandSize32');
export const SetkaBrandSize16 = /* #__PURE__*/ hoc<'SetkaBrandSize16'>(SetkaBrandSize16Glyph, 'SetkaBrandSize16');
export const InstagramBrandSize24 = /* #__PURE__*/ hoc<'InstagramBrandSize24'>(
    InstagramBrandSize24Glyph,
    'InstagramBrandSize24'
);
export const SetkaBrandSize24 = /* #__PURE__*/ hoc<'SetkaBrandSize24'>(SetkaBrandSize24Glyph, 'SetkaBrandSize24');
export const SetkaBrandSize48 = /* #__PURE__*/ hoc<'SetkaBrandSize48'>(SetkaBrandSize48Glyph, 'SetkaBrandSize48');
export const SetkaSolidSize32 = /* #__PURE__*/ hoc<'SetkaSolidSize32'>(SetkaSolidSize32Glyph, 'SetkaSolidSize32');
export const SetkaBrandSize32 = /* #__PURE__*/ hoc<'SetkaBrandSize32'>(SetkaBrandSize32Glyph, 'SetkaBrandSize32');
export const InstagramGrayscaleSize16 = /* #__PURE__*/ hoc<'InstagramGrayscaleSize16'>(
    InstagramGrayscaleSize16Glyph,
    'InstagramGrayscaleSize16'
);
export const HhProBrandSize24 = /* #__PURE__*/ hoc<'HhProBrandSize24'>(HhProBrandSize24Glyph, 'HhProBrandSize24');
export const RabotaByGrayscaleSize24 = /* #__PURE__*/ hoc<'RabotaByGrayscaleSize24'>(
    RabotaByGrayscaleSize24Glyph,
    'RabotaByGrayscaleSize24'
);
export const RabotaByGrayscaleSize16 = /* #__PURE__*/ hoc<'RabotaByGrayscaleSize16'>(
    RabotaByGrayscaleSize16Glyph,
    'RabotaByGrayscaleSize16'
);
export const HrLinkBrandSize24 = /* #__PURE__*/ hoc<'HrLinkBrandSize24'>(HrLinkBrandSize24Glyph, 'HrLinkBrandSize24');
export const InstagramBrandSize16 = /* #__PURE__*/ hoc<'InstagramBrandSize16'>(
    InstagramBrandSize16Glyph,
    'InstagramBrandSize16'
);
export const InstagramGrayscaleSize24 = /* #__PURE__*/ hoc<'InstagramGrayscaleSize24'>(
    InstagramGrayscaleSize24Glyph,
    'InstagramGrayscaleSize24'
);
export const TalantixLiteSize24 = /* #__PURE__*/ hoc<'TalantixLiteSize24'>(
    TalantixLiteSize24Glyph,
    'TalantixLiteSize24'
);
export const TalantixLiteSize16 = /* #__PURE__*/ hoc<'TalantixLiteSize16'>(
    TalantixLiteSize16Glyph,
    'TalantixLiteSize16'
);
export const MaxGrayscaleSize24 = /* #__PURE__*/ hoc<'MaxGrayscaleSize24'>(
    MaxGrayscaleSize24Glyph,
    'MaxGrayscaleSize24'
);
export const MaxSquareGrayscaleSize24 = /* #__PURE__*/ hoc<'MaxSquareGrayscaleSize24'>(
    MaxSquareGrayscaleSize24Glyph,
    'MaxSquareGrayscaleSize24'
);
export const MaxSquareGrayscaleSize16 = /* #__PURE__*/ hoc<'MaxSquareGrayscaleSize16'>(
    MaxSquareGrayscaleSize16Glyph,
    'MaxSquareGrayscaleSize16'
);
export const VkSquareBrandAltSize24 = /* #__PURE__*/ hoc<'VkSquareBrandAltSize24'>(
    VkSquareBrandAltSize24Glyph,
    'VkSquareBrandAltSize24'
);
export const VkSquareBrandAltSize16 = /* #__PURE__*/ hoc<'VkSquareBrandAltSize16'>(
    VkSquareBrandAltSize16Glyph,
    'VkSquareBrandAltSize16'
);
export const MailBrandAltSize16 = /* #__PURE__*/ hoc<'MailBrandAltSize16'>(
    MailBrandAltSize16Glyph,
    'MailBrandAltSize16'
);
export const MailBrandAltSize24 = /* #__PURE__*/ hoc<'MailBrandAltSize24'>(
    MailBrandAltSize24Glyph,
    'MailBrandAltSize24'
);
export const MailBrandSize24 = /* #__PURE__*/ hoc<'MailBrandSize24'>(MailBrandSize24Glyph, 'MailBrandSize24');
export const MailBrandSize16 = /* #__PURE__*/ hoc<'MailBrandSize16'>(MailBrandSize16Glyph, 'MailBrandSize16');
export const OneCGrayscaleSize16 = /* #__PURE__*/ hoc<'OneCGrayscaleSize16'>(
    OneCGrayscaleSize16Glyph,
    'OneCGrayscaleSize16'
);
export const OneCBrandSize32 = /* #__PURE__*/ hoc<'OneCBrandSize32'>(OneCBrandSize32Glyph, 'OneCBrandSize32');
export const OneCBrandSize16 = /* #__PURE__*/ hoc<'OneCBrandSize16'>(OneCBrandSize16Glyph, 'OneCBrandSize16');
export const OneCBrandSize24 = /* #__PURE__*/ hoc<'OneCBrandSize24'>(OneCBrandSize24Glyph, 'OneCBrandSize24');
export const OneCGrayscaleSize24 = /* #__PURE__*/ hoc<'OneCGrayscaleSize24'>(
    OneCGrayscaleSize24Glyph,
    'OneCGrayscaleSize24'
);
export const OneCGrayscaleSize32 = /* #__PURE__*/ hoc<'OneCGrayscaleSize32'>(
    OneCGrayscaleSize32Glyph,
    'OneCGrayscaleSize32'
);
export const YandexCloudGrayscaleSize32 = /* #__PURE__*/ hoc<'YandexCloudGrayscaleSize32'>(
    YandexCloudGrayscaleSize32Glyph,
    'YandexCloudGrayscaleSize32'
);
export const YandexCloudGrayscaleSize24 = /* #__PURE__*/ hoc<'YandexCloudGrayscaleSize24'>(
    YandexCloudGrayscaleSize24Glyph,
    'YandexCloudGrayscaleSize24'
);
export const YandexCloudGrayscaleSize16 = /* #__PURE__*/ hoc<'YandexCloudGrayscaleSize16'>(
    YandexCloudGrayscaleSize16Glyph,
    'YandexCloudGrayscaleSize16'
);
export const YandexCloudBrandSize32 = /* #__PURE__*/ hoc<'YandexCloudBrandSize32'>(
    YandexCloudBrandSize32Glyph,
    'YandexCloudBrandSize32'
);
export const YandexCloudBrandSize24 = /* #__PURE__*/ hoc<'YandexCloudBrandSize24'>(
    YandexCloudBrandSize24Glyph,
    'YandexCloudBrandSize24'
);
export const YandexCloudBrandSize16 = /* #__PURE__*/ hoc<'YandexCloudBrandSize16'>(
    YandexCloudBrandSize16Glyph,
    'YandexCloudBrandSize16'
);
export const IbsBrandSize32 = /* #__PURE__*/ hoc<'IbsBrandSize32'>(IbsBrandSize32Glyph, 'IbsBrandSize32');
export const IbsBrandSize24 = /* #__PURE__*/ hoc<'IbsBrandSize24'>(IbsBrandSize24Glyph, 'IbsBrandSize24');
export const IbsBrandSize16 = /* #__PURE__*/ hoc<'IbsBrandSize16'>(IbsBrandSize16Glyph, 'IbsBrandSize16');
export const IbsGrayscaleSize32 = /* #__PURE__*/ hoc<'IbsGrayscaleSize32'>(
    IbsGrayscaleSize32Glyph,
    'IbsGrayscaleSize32'
);
export const IbsGrayscaleSize24 = /* #__PURE__*/ hoc<'IbsGrayscaleSize24'>(
    IbsGrayscaleSize24Glyph,
    'IbsGrayscaleSize24'
);
export const IbsGrayscaleSize16 = /* #__PURE__*/ hoc<'IbsGrayscaleSize16'>(
    IbsGrayscaleSize16Glyph,
    'IbsGrayscaleSize16'
);
export const RabotaByBrandSize16 = /* #__PURE__*/ hoc<'RabotaByBrandSize16'>(
    RabotaByBrandSize16Glyph,
    'RabotaByBrandSize16'
);
export const RabotaByBrandSize24 = /* #__PURE__*/ hoc<'RabotaByBrandSize24'>(
    RabotaByBrandSize24Glyph,
    'RabotaByBrandSize24'
);
export const ClickmeGrayscaleSize24 = /* #__PURE__*/ hoc<'ClickmeGrayscaleSize24'>(
    ClickmeGrayscaleSize24Glyph,
    'ClickmeGrayscaleSize24'
);
export const ClickmeGrayscaleSize16 = /* #__PURE__*/ hoc<'ClickmeGrayscaleSize16'>(
    ClickmeGrayscaleSize16Glyph,
    'ClickmeGrayscaleSize16'
);
export const MaxBrandSize24 = /* #__PURE__*/ hoc<'MaxBrandSize24'>(MaxBrandSize24Glyph, 'MaxBrandSize24');
export const MaxBrandSize16 = /* #__PURE__*/ hoc<'MaxBrandSize16'>(MaxBrandSize16Glyph, 'MaxBrandSize16');
export const MaxGrayscaleSize16 = /* #__PURE__*/ hoc<'MaxGrayscaleSize16'>(
    MaxGrayscaleSize16Glyph,
    'MaxGrayscaleSize16'
);
export const EsiaGrayscaleSize24 = /* #__PURE__*/ hoc<'EsiaGrayscaleSize24'>(
    EsiaGrayscaleSize24Glyph,
    'EsiaGrayscaleSize24'
);
export const EsiaBrandSize16 = /* #__PURE__*/ hoc<'EsiaBrandSize16'>(EsiaBrandSize16Glyph, 'EsiaBrandSize16');
export const EsiaGrayscaleSize16 = /* #__PURE__*/ hoc<'EsiaGrayscaleSize16'>(
    EsiaGrayscaleSize16Glyph,
    'EsiaGrayscaleSize16'
);
export const EsiaBrandSize24 = /* #__PURE__*/ hoc<'EsiaBrandSize24'>(EsiaBrandSize24Glyph, 'EsiaBrandSize24');
export const HhBusinessAppSolidSize48 = /* #__PURE__*/ hoc<'HhBusinessAppSolidSize48'>(
    HhBusinessAppSolidSize48Glyph,
    'HhBusinessAppSolidSize48'
);
export const MediumSolidSize16 = /* #__PURE__*/ hoc<'MediumSolidSize16'>(MediumSolidSize16Glyph, 'MediumSolidSize16');
export const MaxSquareBrandSize24 = /* #__PURE__*/ hoc<'MaxSquareBrandSize24'>(
    MaxSquareBrandSize24Glyph,
    'MaxSquareBrandSize24'
);
export const GithubSolidSize16 = /* #__PURE__*/ hoc<'GithubSolidSize16'>(GithubSolidSize16Glyph, 'GithubSolidSize16');
export const ClickmeBrandSize16 = /* #__PURE__*/ hoc<'ClickmeBrandSize16'>(
    ClickmeBrandSize16Glyph,
    'ClickmeBrandSize16'
);
export const MaxSquareSolidSize24 = /* #__PURE__*/ hoc<'MaxSquareSolidSize24'>(
    MaxSquareSolidSize24Glyph,
    'MaxSquareSolidSize24'
);
export const FacebookSolidSize24 = /* #__PURE__*/ hoc<'FacebookSolidSize24'>(
    FacebookSolidSize24Glyph,
    'FacebookSolidSize24'
);
export const DreamjobSolidSize16 = /* #__PURE__*/ hoc<'DreamjobSolidSize16'>(
    DreamjobSolidSize16Glyph,
    'DreamjobSolidSize16'
);
export const YandexCloudSolidSize24 = /* #__PURE__*/ hoc<'YandexCloudSolidSize24'>(
    YandexCloudSolidSize24Glyph,
    'YandexCloudSolidSize24'
);
export const AndroidSolidSize24 = /* #__PURE__*/ hoc<'AndroidSolidSize24'>(
    AndroidSolidSize24Glyph,
    'AndroidSolidSize24'
);
export const MaxSquareSolidSize16 = /* #__PURE__*/ hoc<'MaxSquareSolidSize16'>(
    MaxSquareSolidSize16Glyph,
    'MaxSquareSolidSize16'
);
export const OneCSolidSize16 = /* #__PURE__*/ hoc<'OneCSolidSize16'>(OneCSolidSize16Glyph, 'OneCSolidSize16');
export const DreamjobSolidSize24 = /* #__PURE__*/ hoc<'DreamjobSolidSize24'>(
    DreamjobSolidSize24Glyph,
    'DreamjobSolidSize24'
);
export const MaxSolidSize16 = /* #__PURE__*/ hoc<'MaxSolidSize16'>(MaxSolidSize16Glyph, 'MaxSolidSize16');
export const TinkoffIdGrayscaleSize16 = /* #__PURE__*/ hoc<'TinkoffIdGrayscaleSize16'>(
    TinkoffIdGrayscaleSize16Glyph,
    'TinkoffIdGrayscaleSize16'
);
export const HhBusinessAppSolidSize24 = /* #__PURE__*/ hoc<'HhBusinessAppSolidSize24'>(
    HhBusinessAppSolidSize24Glyph,
    'HhBusinessAppSolidSize24'
);
export const OneCSolidSize24 = /* #__PURE__*/ hoc<'OneCSolidSize24'>(OneCSolidSize24Glyph, 'OneCSolidSize24');
export const IcqSolidSize24 = /* #__PURE__*/ hoc<'IcqSolidSize24'>(IcqSolidSize24Glyph, 'IcqSolidSize24');
export const HhBusinessAppSolidSize16 = /* #__PURE__*/ hoc<'HhBusinessAppSolidSize16'>(
    HhBusinessAppSolidSize16Glyph,
    'HhBusinessAppSolidSize16'
);
export const YandexCloudSolidSize16 = /* #__PURE__*/ hoc<'YandexCloudSolidSize16'>(
    YandexCloudSolidSize16Glyph,
    'YandexCloudSolidSize16'
);
export const MaxSquareBrandSize16 = /* #__PURE__*/ hoc<'MaxSquareBrandSize16'>(
    MaxSquareBrandSize16Glyph,
    'MaxSquareBrandSize16'
);
export const ZarplataSolidSize24 = /* #__PURE__*/ hoc<'ZarplataSolidSize24'>(
    ZarplataSolidSize24Glyph,
    'ZarplataSolidSize24'
);
export const YandexCloudSolidSize32 = /* #__PURE__*/ hoc<'YandexCloudSolidSize32'>(
    YandexCloudSolidSize32Glyph,
    'YandexCloudSolidSize32'
);
export const TalantixSolidSize24 = /* #__PURE__*/ hoc<'TalantixSolidSize24'>(
    TalantixSolidSize24Glyph,
    'TalantixSolidSize24'
);
export const ImessageSolidSize24 = /* #__PURE__*/ hoc<'ImessageSolidSize24'>(
    ImessageSolidSize24Glyph,
    'ImessageSolidSize24'
);
export const IndexSolidSize16 = /* #__PURE__*/ hoc<'IndexSolidSize16'>(IndexSolidSize16Glyph, 'IndexSolidSize16');
export const TinkoffIdBrandSize16 = /* #__PURE__*/ hoc<'TinkoffIdBrandSize16'>(
    TinkoffIdBrandSize16Glyph,
    'TinkoffIdBrandSize16'
);
export const VkSquareSolidSize16 = /* #__PURE__*/ hoc<'VkSquareSolidSize16'>(
    VkSquareSolidSize16Glyph,
    'VkSquareSolidSize16'
);
export const ClickmeBrandSize24 = /* #__PURE__*/ hoc<'ClickmeBrandSize24'>(
    ClickmeBrandSize24Glyph,
    'ClickmeBrandSize24'
);
export const TwitterSolidSize16 = /* #__PURE__*/ hoc<'TwitterSolidSize16'>(
    TwitterSolidSize16Glyph,
    'TwitterSolidSize16'
);
export const YandexSolidSize24 = /* #__PURE__*/ hoc<'YandexSolidSize24'>(YandexSolidSize24Glyph, 'YandexSolidSize24');
export const HhProSolidSize24 = /* #__PURE__*/ hoc<'HhProSolidSize24'>(HhProSolidSize24Glyph, 'HhProSolidSize24');
export const FacebookSolidSize16 = /* #__PURE__*/ hoc<'FacebookSolidSize16'>(
    FacebookSolidSize16Glyph,
    'FacebookSolidSize16'
);
export const InstagramSolidSize16 = /* #__PURE__*/ hoc<'InstagramSolidSize16'>(
    InstagramSolidSize16Glyph,
    'InstagramSolidSize16'
);
export const OneCSolidSize32 = /* #__PURE__*/ hoc<'OneCSolidSize32'>(OneCSolidSize32Glyph, 'OneCSolidSize32');
export const GithubSolidSize24 = /* #__PURE__*/ hoc<'GithubSolidSize24'>(GithubSolidSize24Glyph, 'GithubSolidSize24');
export const IcqSolidSize16 = /* #__PURE__*/ hoc<'IcqSolidSize16'>(IcqSolidSize16Glyph, 'IcqSolidSize16');
export const TinkoffIdGrayscaleSize24 = /* #__PURE__*/ hoc<'TinkoffIdGrayscaleSize24'>(
    TinkoffIdGrayscaleSize24Glyph,
    'TinkoffIdGrayscaleSize24'
);
export const TalantixSolidSize16 = /* #__PURE__*/ hoc<'TalantixSolidSize16'>(
    TalantixSolidSize16Glyph,
    'TalantixSolidSize16'
);
export const YandexSolidSize16 = /* #__PURE__*/ hoc<'YandexSolidSize16'>(YandexSolidSize16Glyph, 'YandexSolidSize16');
export const IndexSolidSize24 = /* #__PURE__*/ hoc<'IndexSolidSize24'>(IndexSolidSize24Glyph, 'IndexSolidSize24');
export const TinkoffIdBrandSize24 = /* #__PURE__*/ hoc<'TinkoffIdBrandSize24'>(
    TinkoffIdBrandSize24Glyph,
    'TinkoffIdBrandSize24'
);
export const ViberSolidSize24 = /* #__PURE__*/ hoc<'ViberSolidSize24'>(ViberSolidSize24Glyph, 'ViberSolidSize24');
export const InstagramSolidSize24 = /* #__PURE__*/ hoc<'InstagramSolidSize24'>(
    InstagramSolidSize24Glyph,
    'InstagramSolidSize24'
);
export const VkSquareSolidSize24 = /* #__PURE__*/ hoc<'VkSquareSolidSize24'>(
    VkSquareSolidSize24Glyph,
    'VkSquareSolidSize24'
);
export const AndroidSolidSize16 = /* #__PURE__*/ hoc<'AndroidSolidSize16'>(
    AndroidSolidSize16Glyph,
    'AndroidSolidSize16'
);
export const HhProSolidSize32 = /* #__PURE__*/ hoc<'HhProSolidSize32'>(HhProSolidSize32Glyph, 'HhProSolidSize32');
export const ViberSolidSize16 = /* #__PURE__*/ hoc<'ViberSolidSize16'>(ViberSolidSize16Glyph, 'ViberSolidSize16');
export const ImessageSolidSize16 = /* #__PURE__*/ hoc<'ImessageSolidSize16'>(
    ImessageSolidSize16Glyph,
    'ImessageSolidSize16'
);
export const ZarplataSolidSize16 = /* #__PURE__*/ hoc<'ZarplataSolidSize16'>(
    ZarplataSolidSize16Glyph,
    'ZarplataSolidSize16'
);
export const TwitterSolidSize24 = /* #__PURE__*/ hoc<'TwitterSolidSize24'>(
    TwitterSolidSize24Glyph,
    'TwitterSolidSize24'
);
export const HhProSolidSize16 = /* #__PURE__*/ hoc<'HhProSolidSize16'>(HhProSolidSize16Glyph, 'HhProSolidSize16');
export const MaxSolidSize24 = /* #__PURE__*/ hoc<'MaxSolidSize24'>(MaxSolidSize24Glyph, 'MaxSolidSize24');
export const IbsSolidSize32 = /* #__PURE__*/ hoc<'IbsSolidSize32'>(IbsSolidSize32Glyph, 'IbsSolidSize32');
export const AppleBrandSize24 = /* #__PURE__*/ hoc<'AppleBrandSize24'>(AppleBrandSize24Glyph, 'AppleBrandSize24');
export const IbsSolidSize16 = /* #__PURE__*/ hoc<'IbsSolidSize16'>(IbsSolidSize16Glyph, 'IbsSolidSize16');
export const IbsSolidSize24 = /* #__PURE__*/ hoc<'IbsSolidSize24'>(IbsSolidSize24Glyph, 'IbsSolidSize24');
export const AppleBrandSize16 = /* #__PURE__*/ hoc<'AppleBrandSize16'>(AppleBrandSize16Glyph, 'AppleBrandSize16');
export const MediumSolidSize24 = /* #__PURE__*/ hoc<'MediumSolidSize24'>(MediumSolidSize24Glyph, 'MediumSolidSize24');
export const StackoverflowSolidSize16 = /* #__PURE__*/ hoc<'StackoverflowSolidSize16'>(
    StackoverflowSolidSize16Glyph,
    'StackoverflowSolidSize16'
);
export const StackoverflowSolidSize24 = /* #__PURE__*/ hoc<'StackoverflowSolidSize24'>(
    StackoverflowSolidSize24Glyph,
    'StackoverflowSolidSize24'
);
export const AppleSolidSize24 = /* #__PURE__*/ hoc<'AppleSolidSize24'>(AppleSolidSize24Glyph, 'AppleSolidSize24');
export const VkSolidSize24 = /* #__PURE__*/ hoc<'VkSolidSize24'>(VkSolidSize24Glyph, 'VkSolidSize24');
export const AppleSolidSize16 = /* #__PURE__*/ hoc<'AppleSolidSize16'>(AppleSolidSize16Glyph, 'AppleSolidSize16');
export const HhBusinessAppBrandSize48 = /* #__PURE__*/ hoc<'HhBusinessAppBrandSize48'>(
    HhBusinessAppBrandSize48Glyph,
    'HhBusinessAppBrandSize48'
);
export const GoogleSolidSize16 = /* #__PURE__*/ hoc<'GoogleSolidSize16'>(GoogleSolidSize16Glyph, 'GoogleSolidSize16');
export const SetkaSolidSize24 = /* #__PURE__*/ hoc<'SetkaSolidSize24'>(SetkaSolidSize24Glyph, 'SetkaSolidSize24');
export const DnrSolidSize16 = /* #__PURE__*/ hoc<'DnrSolidSize16'>(DnrSolidSize16Glyph, 'DnrSolidSize16');
export const DzenSolidSize24 = /* #__PURE__*/ hoc<'DzenSolidSize24'>(DzenSolidSize24Glyph, 'DzenSolidSize24');
export const DzenSolidSize16 = /* #__PURE__*/ hoc<'DzenSolidSize16'>(DzenSolidSize16Glyph, 'DzenSolidSize16');
export const SetkaSolidSize16 = /* #__PURE__*/ hoc<'SetkaSolidSize16'>(SetkaSolidSize16Glyph, 'SetkaSolidSize16');
export const SetkaSolidSize48 = /* #__PURE__*/ hoc<'SetkaSolidSize48'>(SetkaSolidSize48Glyph, 'SetkaSolidSize48');
export const GoogleSolidSize24 = /* #__PURE__*/ hoc<'GoogleSolidSize24'>(GoogleSolidSize24Glyph, 'GoogleSolidSize24');
export const TinkoffIdSolidSize16 = /* #__PURE__*/ hoc<'TinkoffIdSolidSize16'>(
    TinkoffIdSolidSize16Glyph,
    'TinkoffIdSolidSize16'
);
export const RabotaBySolidSize24 = /* #__PURE__*/ hoc<'RabotaBySolidSize24'>(
    RabotaBySolidSize24Glyph,
    'RabotaBySolidSize24'
);
export const TinkoffIdSolidSize24 = /* #__PURE__*/ hoc<'TinkoffIdSolidSize24'>(
    TinkoffIdSolidSize24Glyph,
    'TinkoffIdSolidSize24'
);
export const FlSolidSize24 = /* #__PURE__*/ hoc<'FlSolidSize24'>(FlSolidSize24Glyph, 'FlSolidSize24');
export const TelegramSolidSize24 = /* #__PURE__*/ hoc<'TelegramSolidSize24'>(
    TelegramSolidSize24Glyph,
    'TelegramSolidSize24'
);
export const MailSolidSize24 = /* #__PURE__*/ hoc<'MailSolidSize24'>(MailSolidSize24Glyph, 'MailSolidSize24');
export const LivejournalSolidSize16 = /* #__PURE__*/ hoc<'LivejournalSolidSize16'>(
    LivejournalSolidSize16Glyph,
    'LivejournalSolidSize16'
);
export const ClickmeSolidSize16 = /* #__PURE__*/ hoc<'ClickmeSolidSize16'>(
    ClickmeSolidSize16Glyph,
    'ClickmeSolidSize16'
);
export const FlSolidSize16 = /* #__PURE__*/ hoc<'FlSolidSize16'>(FlSolidSize16Glyph, 'FlSolidSize16');
export const TelegramSolidSize16 = /* #__PURE__*/ hoc<'TelegramSolidSize16'>(
    TelegramSolidSize16Glyph,
    'TelegramSolidSize16'
);
export const ClickmeSolidSize24 = /* #__PURE__*/ hoc<'ClickmeSolidSize24'>(
    ClickmeSolidSize24Glyph,
    'ClickmeSolidSize24'
);
export const MailSolidSize16 = /* #__PURE__*/ hoc<'MailSolidSize16'>(MailSolidSize16Glyph, 'MailSolidSize16');
export const SkypeSolidSize24 = /* #__PURE__*/ hoc<'SkypeSolidSize24'>(SkypeSolidSize24Glyph, 'SkypeSolidSize24');
export const EsiaSolidSize24 = /* #__PURE__*/ hoc<'EsiaSolidSize24'>(EsiaSolidSize24Glyph, 'EsiaSolidSize24');
export const EsiaSolidSize16 = /* #__PURE__*/ hoc<'EsiaSolidSize16'>(EsiaSolidSize16Glyph, 'EsiaSolidSize16');
export const HrLinkSolidSize16 = /* #__PURE__*/ hoc<'HrLinkSolidSize16'>(HrLinkSolidSize16Glyph, 'HrLinkSolidSize16');
export const HhSolidSize24 = /* #__PURE__*/ hoc<'HhSolidSize24'>(HhSolidSize24Glyph, 'HhSolidSize24');
export const LinkedinSolidSize24 = /* #__PURE__*/ hoc<'LinkedinSolidSize24'>(
    LinkedinSolidSize24Glyph,
    'LinkedinSolidSize24'
);
export const LinkedinSolidSize16 = /* #__PURE__*/ hoc<'LinkedinSolidSize16'>(
    LinkedinSolidSize16Glyph,
    'LinkedinSolidSize16'
);
export const WhatsappSolidSize24 = /* #__PURE__*/ hoc<'WhatsappSolidSize24'>(
    WhatsappSolidSize24Glyph,
    'WhatsappSolidSize24'
);
export const HrLinkSolidSize24 = /* #__PURE__*/ hoc<'HrLinkSolidSize24'>(HrLinkSolidSize24Glyph, 'HrLinkSolidSize24');
export const WhatsappSolidSize16 = /* #__PURE__*/ hoc<'WhatsappSolidSize16'>(
    WhatsappSolidSize16Glyph,
    'WhatsappSolidSize16'
);
export const GithubBrandSize24 = /* #__PURE__*/ hoc<'GithubBrandSize24'>(GithubBrandSize24Glyph, 'GithubBrandSize24');
export const HhSolidSize16 = /* #__PURE__*/ hoc<'HhSolidSize16'>(HhSolidSize16Glyph, 'HhSolidSize16');
export const OkSolidSize16 = /* #__PURE__*/ hoc<'OkSolidSize16'>(OkSolidSize16Glyph, 'OkSolidSize16');
export const RabotaByAppBrandAltSize48 = /* #__PURE__*/ hoc<'RabotaByAppBrandAltSize48'>(
    RabotaByAppBrandAltSize48Glyph,
    'RabotaByAppBrandAltSize48'
);
export const RabotaByAppBrandAltSize24 = /* #__PURE__*/ hoc<'RabotaByAppBrandAltSize24'>(
    RabotaByAppBrandAltSize24Glyph,
    'RabotaByAppBrandAltSize24'
);
export const RabotaByAppBrandAltSize16 = /* #__PURE__*/ hoc<'RabotaByAppBrandAltSize16'>(
    RabotaByAppBrandAltSize16Glyph,
    'RabotaByAppBrandAltSize16'
);
export const RabotaByAppGrayscaleSize48 = /* #__PURE__*/ hoc<'RabotaByAppGrayscaleSize48'>(
    RabotaByAppGrayscaleSize48Glyph,
    'RabotaByAppGrayscaleSize48'
);
export const HhBusinessAppBrandSize16 = /* #__PURE__*/ hoc<'HhBusinessAppBrandSize16'>(
    HhBusinessAppBrandSize16Glyph,
    'HhBusinessAppBrandSize16'
);
export const HhBusinessAppGrayscaleSize16 = /* #__PURE__*/ hoc<'HhBusinessAppGrayscaleSize16'>(
    HhBusinessAppGrayscaleSize16Glyph,
    'HhBusinessAppGrayscaleSize16'
);
export const HhBusinessAppGrayscaleSize24 = /* #__PURE__*/ hoc<'HhBusinessAppGrayscaleSize24'>(
    HhBusinessAppGrayscaleSize24Glyph,
    'HhBusinessAppGrayscaleSize24'
);
export const HhBusinessAppBrandSize24 = /* #__PURE__*/ hoc<'HhBusinessAppBrandSize24'>(
    HhBusinessAppBrandSize24Glyph,
    'HhBusinessAppBrandSize24'
);
export const HhBusinessAppGrayscaleSize48 = /* #__PURE__*/ hoc<'HhBusinessAppGrayscaleSize48'>(
    HhBusinessAppGrayscaleSize48Glyph,
    'HhBusinessAppGrayscaleSize48'
);
export const RabotaByAppSolidSize16 = /* #__PURE__*/ hoc<'RabotaByAppSolidSize16'>(
    RabotaByAppSolidSize16Glyph,
    'RabotaByAppSolidSize16'
);
export const RabotaByAppGrayscaleSize24 = /* #__PURE__*/ hoc<'RabotaByAppGrayscaleSize24'>(
    RabotaByAppGrayscaleSize24Glyph,
    'RabotaByAppGrayscaleSize24'
);
export const RabotaByAppGrayscaleSize16 = /* #__PURE__*/ hoc<'RabotaByAppGrayscaleSize16'>(
    RabotaByAppGrayscaleSize16Glyph,
    'RabotaByAppGrayscaleSize16'
);
export const RabotaByAppBrandSize48 = /* #__PURE__*/ hoc<'RabotaByAppBrandSize48'>(
    RabotaByAppBrandSize48Glyph,
    'RabotaByAppBrandSize48'
);
export const RabotaByAppBrandSize24 = /* #__PURE__*/ hoc<'RabotaByAppBrandSize24'>(
    RabotaByAppBrandSize24Glyph,
    'RabotaByAppBrandSize24'
);
export const RabotaByAppBrandSize16 = /* #__PURE__*/ hoc<'RabotaByAppBrandSize16'>(
    RabotaByAppBrandSize16Glyph,
    'RabotaByAppBrandSize16'
);
export const RabotaByAppSolidSize48 = /* #__PURE__*/ hoc<'RabotaByAppSolidSize48'>(
    RabotaByAppSolidSize48Glyph,
    'RabotaByAppSolidSize48'
);
export const RabotaByAppSolidSize24 = /* #__PURE__*/ hoc<'RabotaByAppSolidSize24'>(
    RabotaByAppSolidSize24Glyph,
    'RabotaByAppSolidSize24'
);
